import { Controller } from "@hotwired/stimulus"

// Prints the page: on click, or once on load with `data-print-auto-value`
// (the invoice document opens in a new tab ready to save as PDF).
export default class extends Controller {
  static values = { auto: Boolean }

  connect() {
    if (this.autoValue) window.print()
  }

  print() {
    window.print()
  }
}
